import { render, staticRenderFns } from "./BeritaAdd.vue?vue&type=template&id=86c03208&scoped=true"
import script from "./BeritaAdd.vue?vue&type=script&lang=js"
export * from "./BeritaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c03208",
  null
  
)

export default component.exports